<template>
    <div>
        <ejs-button  cssClass='e-link' v-if='isAvailable' v-on:click.native='contractBtnClick(contractId)'>{{contractName}}</ejs-button>
        <span v-else>{{contractName}}</span>
    </div>
</template>

<script>
    import Vue from "vue";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import router from '../../router/index';

    Vue.use(ButtonPlugin);
    export default {
        name: 'ColumnTemplate',
        data() {
            return {
                data: {
                    //isAvailable: true
                }
            }
        },
        methods: {
            contractBtnClick: function (id) {
                router.push({ name: "Reports UI", params: { contractId: id } });
            }
        },
        computed: {
            contractId: function () {
                return this.data.contractId;
            },
            contractName: function () {
                return this.data.contractName;
            },
            isAvailable: function () {
                return this.$store.state.permissions["Permissions.Reports.View"] ? true : false;
            }
        }
    }
</script>

<style scoped>
</style>